<template>
  <v-app-bar v-if="showExpiredBar" color="danger" elevation="0" height="40">
    <v-row class="ma-0 v-center h-center">
      <v-icon size="small" class="mr-2" color="white">mdi-alert </v-icon>
      <span class="hint pr-3" v-html="$t('app.licenseExpired')" />
      <v-btn
        class="text-none pb-1"
        variant="tonal"
        slim
        density="compact"
        @click="showLicenseMenu"
      >
        {{ $t('app.myLicenses') }}
      </v-btn>
    </v-row>
  </v-app-bar>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

import { mapState } from 'pinia';
import { authenticationStore } from '@/store/pinia/AuthenticationStore';

export default defineComponent({
  name: 'ExpiredBar',
  computed: {
    ...mapState(authenticationStore, ['showExpiredBar'])
  },
  methods: {
    showLicenseMenu() {
      if (this.$route.path !== '/licenses') void this.$router.push('/licenses');
    }
  }
});
</script>

<style scoped lang="scss">
.hint {
  font-size: 14px;
  cursor: default;
}

.hint:deep(a) {
  text-decoration: underline !important;
  color: white !important;
}

.hint:deep(a:hover) {
  text-decoration: none !important;
}
</style>
